<script>
import ApplicationsListFilters from 'components/applications/ApplicationsListFilters'

export default {
  extends: ApplicationsListFilters,

  props: {
    placeholder: {
      type: String,
      default: 'Find cluster by name'
    }
  }
}
</script>
